import { useState } from 'react';

interface ConfirmModalOptions {
  title: string;
  description: string | React.ReactNode;
  continueText?: string;
  cancelText?: string;
  onContinue: () => void;
  onCancel?: () => void;
}

export const useConfirmModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<ConfirmModalOptions | null>(null);

  const confirm = (opts: ConfirmModalOptions) => {
    setOptions(opts);
    setIsOpen(true);
  };

  const handleContinue = () => {
    if (options?.onContinue) {
      options.onContinue();
    }

    setIsOpen(false);
    setOptions(null);
  };

  const handleCancel = () => {
    if (options?.onCancel) {
      options.onCancel();
    }

    setIsOpen(false);
    setOptions(null);
  };

  return {
    isOpen,
    options,
    confirm,
    handleContinue,
    handleCancel,
  };
};
